import type { FaireProductEntity } from "../../entity_types/product";

export const p_mzrmu6xbsd: FaireProductEntity = {
  token: "p_mzrmu6xbsd",
  type: "product",
  name: "Moissanite Diamond Ring: 925 Silver Gold-plated Jewelry",
  brandToken: "b_uq6uf6uvrw",
  brandName: "Jay Jools",
  imageUrl:
    "https://cdn.faire.com/fastly/2ce695929e95d41fa8d6401ff9a9b766c4ad76f6f54356c9b7010c88eb55e41e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d2bedb65bf7b574465153dbc6ab5f46472eb86594c871841f8efc94b848e1428.jpeg",
    "https://cdn.faire.com/fastly/949bac8cd170b90fbb05ce8ecef18b95020e163c9243394defd82fbf463f04ce.jpeg",
    "https://cdn.faire.com/fastly/b033c5966b9f36f35270994a7232ceef0fee42774665ffd27e52e628c085a73e.jpeg",
    "https://cdn.faire.com/fastly/a1309fb1eb1c96a2061225dcdcd54cb691d0b205ce4b9ef5ab99ec42a484d2f0.jpeg",
    "https://cdn.faire.com/fastly/f4bb609ade699cddfaafffcd6c58d849a7b628875edcc173bbdf12903b7bfaa4.jpeg",
    "https://cdn.faire.com/fastly/25ac0834b05e40ceb90cf86c9cf6e68998b6fc86d1d19d91b20cdb3cd561355b.jpeg",
  ],
  priceDollars: 124.7,
  description:
    "Introducing our stunning Moissanite Diamond Ring in 925 Sterling Silver with Gold Plating, perfect for those who love elegant, minimalist jewelry. This handmade piece features a dazzling Moissanite Diamond that sparkles brilliantly, making it an ideal choice for engagement rings or special occasions. Crafted with care and precision, this ring showcases a timeless design that effortlessly enhances any outfit. Treat yourself or a loved one to this exquisite piece of jewelry.\n\nProduct Details\n\nGemstone: Moissanite Diamond\nMetal: 925 Sterling Silver (SR1339YG)\nFinish: 18k Gold Plated\nStyle: Ring\nPackaging: Gift-ready box included\n\nWhy Choose JAY JOOLS\n\nHandcrafted in our in-house studio\nMade with 100% genuine, natural gemstones\nHallmarked 925, with 92.5%+ pure silver guaranteed\nSuperior 1-micron plating for lasting quality\nAvailable in Silver, Gold, and Rose Gold—plated over solid 925 Sterling Silver.\n\nNote: As each stone is natural, slight variations in texture and color are expected, ensuring that every piece is unique. Stone quality will always match what’s shown.",
  tags: [],
  msrpDollars: 249.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:59:26.081Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
